import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'app/lang';

import { switchToAllowPricePreference } from '../../../../actions/preferences';
import { AllowingPricePreference } from '../../../../constants';

import dictionary from './Settings.dictionary.json';

export type SegmentedOption = {
  id: AllowingPricePreference;
  onSelect?: (option: SegmentedOption) => void;
  value: string;
  dataTest?: string;
  dataGaEvent?: string;
};

export function useSegmentedOptions():SegmentedOption[] {
  const { t, lang } = useTranslation();
  const dispatch = useDispatch();

  const onSelectHandler = (value: AllowingPricePreference) => () => {
    dispatch(switchToAllowPricePreference(value));
  };

  return useMemo(() => [
    {
      id: AllowingPricePreference.NOTHING,
      value: t(dictionary.noPrice),
      dataTest: 'noCashoutIncrease',
      dataGaEvent: 'cart-set-notIncreaseAndDecrease',
      onSelect: onSelectHandler(AllowingPricePreference.NOTHING),
    },
    {
      id: AllowingPricePreference.ONLY_INCREASE,
      value: t(dictionary.priceIncrease),
      dataTest: 'cashoutIncrease-button',
      dataGaEvent: 'cart-set-notIncrease',
      onSelect: onSelectHandler(AllowingPricePreference.ONLY_INCREASE),
    },
    {
      id: AllowingPricePreference.EVERYTHING,
      value: t(dictionary.priceIncreaseAndDecrease),
      dataTest: 'cashoutIncreaseAndDecrease-button',
      dataGaEvent: 'cart-set-increaseAndDecrease',
      onSelect: onSelectHandler(AllowingPricePreference.EVERYTHING),
    },
  ], [lang]);
}
